import React, { useState, useEffect, useContext } from "react";
import errorRedIcon from "../../images/errorRedIcon.png";
import errorIcon from "../../images/errorRedIcon.png";
import successIcon from "../../images/successGreenIcon.png";
import LoadingIcon from "../../images/Loading_icon.gif";
import Swal from "sweetalert2";
import UpdateUser from "./UpdateUser";
import userDefaultImage from "../../images/default-profile.png";
import { UrlContext } from "../../contexts/UrlContext";

export default function UserRow({
  user,
  adminUser,
  currentUser,
  setShowSelectImage,
  setDataForImageUpload,
}) {
  const { API_URL } = useContext(UrlContext);
  const [deletePopup, setDeletePopup] = useState(false);
  const [deleted, setDeleted] = useState(false);
  const [currUserName, setCurrUserName] = useState(null);
  const [sameUser, setSameUser] = useState(false);
  const [labelClicked, setLabelClicked] = useState(false);
  const [returnSuccess, setReturnSuccess] = useState(false);
  const [returnError, setReturnError] = useState(false);
  const [loading, setLoading] = useState(false);

  const updateUserData = (exObject) => {
    var newList = [];
    for (let i = 0; i < Object.keys(exObject.roles).length; i++) {
      newList.push(exObject.roles[i]["name"]);
    }
    var strRole = newList.join(", ");
    // console.log(strRole)
    setUserData({
      profilePicture: exObject.profilePicture,
      fullName: exObject.fullName,
      username: exObject.username,
      email: exObject.email,
      roles: strRole,
    });
    // setUserData(exObject)
  };

  const [userData, setUserData] = useState({
    profilePicture: "",
    fullName: "",
    username: "",
    email: "",
    roles: "",
    isActive: "",
  });

  useEffect(() => {
    setUserData({
      profilePicture: user.profilePicture,
      fullName: user.name,
      username: user.username,
      email: user.email,
      roles: user.roles,
      isActive: user.isActive,
    });
  }, [user]);

  const deleteUserHandler = () => {
    const userID = user.id;
    console.log(userID);
    const url = `${API_URL}delete-eph-user`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userID: userID,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setDeletePopup(false);
        if (data.status === "success") {
          Swal.fire({
            title: "Success!",
            text: "User has been deleted successfully!",
            icon: "success",
            confirmButtonText: "OK",
          });
          setDeleted(true);
        } else {
          Swal.fire({
            title: "Error!",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          title: "Error!",
          text: "Something went wrong!",
          icon: "error",
          confirmButtonText: "OK",
        });
      });
  };

  const handleUpdateStatus = (value) => {
    setReturnError(false);
    setLoading(true);
    const userID = user.id;
    const url = `${API_URL}update-user-status`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userID: userID,
        status: value,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        if (data.status === "success") {
          setReturnSuccess(true);
          setUserData({
            profilePicture: user.profilePicture,
            fullName: user.name,
            username: user.username,
            email: user.email,
            roles: user.roles,
            isActive: value,
          });
          setTimeout(() => {
            setReturnSuccess(false);
          }, 1500);
        } else {
          setReturnError(true);
        }
      })
      .catch((err) => {
        setLoading(false);
        setReturnError(true);
        Swal.fire({
          title: "Error!",
          text: "Something went wrong!",
          icon: "error",
          confirmButtonText: "OK",
        });
      });
  };

  if (deleted) {
    return null;
  }
  return (
    <>
      <tr key={user.id}>
        <td>
          <span>
            <label
              htmlFor="upload-button"
              onClick={() => {
                console.log(
                  currUserName,
                  userData.username,
                  user.id,
                  currentUser.id
                );
                console.log(sameUser);
                if (currentUser.id === user.id) {
                  setShowSelectImage(true);
                  // console.log(userData)
                  setDataForImageUpload(userData);
                }
              }}
            >
              <img
                className="image media-object mw150 rounded-circle"
                alt=""
                src={
                  userData.profilePicture
                    ? userData.profilePicture
                    : userDefaultImage
                }
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = userDefaultImage;
                }}
              />
            </label>
          </span>
        </td>
        <td>{userData.username}</td>
        <td>{userData.fullName}</td>
        <td>{userData.email}</td>
        <td>{userData.roles}</td>
        <td className="status-bar-td">
          <select
            className={`progress-list prjstatus-options ${
              userData.isActive === "yes" ? "isActive" : "isInActive"
            }`}
            // style={selectProjectStatusStyle}
            onChange={(e) => handleUpdateStatus(e.target.value)}
            value={userData.isActive}
          >
            <option value="yes">Active</option>
            <option value="no">Inactive</option>
          </select>
          {loading && (
            <img
              className="return-msg-icon"
              style={{ top: "35px", left: "155px" }}
              src={LoadingIcon}
              alt="loading"
              title="Loading..."
            />
          )}
          {returnSuccess && (
            <img
              className="return-msg-icon"
              style={{ top: "35px", left: "155px" }}
              src={successIcon}
              alt="success"
              title="Success"
            />
          )}
          {returnError && (
            <img
              className="return-msg-icon"
              style={{ top: "35px", left: "155px" }}
              src={errorIcon}
              alt="error"
              title="Error! Please reload"
            />
          )}
        </td>
        {adminUser ? (
          <>
            <td>
              <UpdateUser
                user_id={user.id}
                user_FullName={user.name}
                user_name={user.username}
                user_email={user.email}
                user_roles={user.roles}
                updateUserData={updateUserData}
                profilePicture={userData.profilePicture}
              />
            </td>
            <td>
              <i
                className="fa-solid fa-trash-can"
                onClick={() => setDeletePopup(true)}
              ></i>
            </td>
          </>
        ) : null}
      </tr>

      {deletePopup && (
        <div className="deleteUser-popup-wrapper">
          <div className="tab-pane fade show deleteUser-div">
            <div>
              <center>
                <img
                  src={errorRedIcon}
                  width="50px"
                  height="50px"
                  alt="alert-icon"
                />
                <p>
                  <strong>WARNING!</strong> User will be permanently removed!
                </p>
                <br />
              </center>
            </div>
            <div>
              <center>
                <button
                  className="btn btn-light"
                  onClick={() => setDeletePopup(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn base-btn"
                  style={{ marginLeft: 6 }}
                  onClick={deleteUserHandler}
                >
                  Continue
                </button>
              </center>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
